function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Layout, Menu, Drawer, Button, Statistic, Descriptions, DatePicker } from 'antd';
import { List, EmojiSmileFill } from 'react-bootstrap-icons';
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { Container, Col, Row } from 'react-bootstrap';
import Common from '../components/includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var RangePicker = DatePicker.RangePicker;
var CompanyReports = function CompanyReports() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    userid = _useParams.userid;
  var _useState = useState(Common.currentUser),
    _useState2 = _slicedToArray(_useState, 2),
    user = _useState2[0],
    setUser = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    authProcessing = _useState4[0],
    setAuthProcessing = _useState4[1];
  useEffect(function () {
    var uid = Common.currentUser != null ? Common.currentUser.id : userid;
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: uid
    }).then(function (response) {
      setAuthProcessing(false);
      if (response.data.authenticated == true) {
        setUser(response.data.user);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        navigate('/');
      }
    })["catch"](function (error) {});
    if (user == null) {
      setUser(Common.currentUser);
    }
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsx(Layout, {
      style: {
        minHeight: '100vh'
      },
      children: /*#__PURE__*/_jsxs(Layout, {
        className: "site-layout",
        children: [/*#__PURE__*/_jsx(Header, {
          className: "site-layout-background",
          style: {
            padding: 0
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 2,
                md: 2,
                sm: 2,
                xs: 3,
                children: /*#__PURE__*/_jsx("div", {
                  style: {
                    width: '80px'
                  },
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/gsl_logo.png",
                    style: {
                      width: '100%'
                    }
                  })
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 5,
                sm: 6,
                xs: 6,
                children: /*#__PURE__*/_jsx(RangePicker, {})
              }), /*#__PURE__*/_jsx(Col, {
                lg: {
                  span: 4,
                  offset: 0
                },
                md: {
                  span: 4,
                  offset: 0
                },
                sm: {
                  span: 4,
                  offset: 0
                },
                xs: {
                  span: 5,
                  offset: 0
                },
                children: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(EmojiSmileFill, {
                    size: 25
                  }), " ", user != null && ' ' + user.firstname, " , bonjour"]
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            margin: '0 16px',
            paddingTop: '30px'
          },
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(Row, {
              children: /*#__PURE__*/_jsxs(Col, {
                lg: 8,
                md: 9,
                children: [/*#__PURE__*/_jsx("div", {
                  className: "cool-radius",
                  style: {
                    backgroundColor: '#2658A4'
                  },
                  children: /*#__PURE__*/_jsx(Descriptions, {
                    title: /*#__PURE__*/_jsx("b", {
                      children: "INFOS Entreprise"
                    })
                  })
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      className: "cool-radius white-bg",
                      children: /*#__PURE__*/_jsx(Statistic, {
                        prefix: "GNF",
                        valueStyle: null,
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Facture totale"
                        }),
                        value: 2000000
                      })
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 6,
                    md: 6,
                    sm: 6,
                    children: /*#__PURE__*/_jsx("div", {
                      className: "cool-radius white-bg",
                      children: /*#__PURE__*/_jsx(Statistic, {
                        valueStyle: null,
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Nbre Consultations"
                        }),
                        value: 20
                      })
                    })
                  })]
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "GuisoftLab \xA92022 Tous droits r\xE9serv\xE9s"
        })]
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default CompanyReports;